import React from 'react';

// Notice we are NOT importing from 'react-native' anymore
export default function ChildSafety() {
  return (
    <div style={{
      padding: '40px',
      backgroundColor: '#fff',
      maxWidth: '900px',
      margin: '0 auto',
      textAlign: 'left'
    }}>
      <h1>Child Safety Standards & CSAE Prevention Policy</h1>
      <p>Last updated: February 03, 2026</p>
      <p>
        <b>Commitment:</b> Rōpū Whakatau has a zero-tolerance policy for any content that depicts or encourages child sexual abuse or exploitation.
        <br></br>
        <b>Prohibited Content:</b> We strictly prohibit the upload, sharing, or storage of any material that exploits or endangers minors. This includes, but is not limited to, CSAE, grooming, and child trafficking.
        <br></br>
        <b>Reporting Mechanisms:</b> Users can report any suspicious activity or content directly within the app by clicking the "Report" button on any user profile or community post.
        <br></br>
        <b>Our Response:</b> All reports involving child safety are prioritized for immediate review. If illegal content is found, we will permanently ban the account and preserve evidence.
        <br></br>
        <b>Law Enforcement Cooperation:</b> We comply with international laws and will report any discovery of CSAE to the National Center for Missing & Exploited Children (NCMEC) and relevant local authorities.
        <br></br>
      </p>
      <h2>Contact Us</h2>
      <p>If you have any questions about this Policy, You can contact us:</p>
      <ul>
        <li>By email: genkidesu12039@outlook.co.nz</li>
      </ul>
    </div>
  );
}